<input
  autocomplete="off"
  id="findRange"
  class="toolbarField"
  title="pages to search"
  [placeholder]="'pages (e.g. 6-10)'"
  data-l10n-id="find_range"
  name="search-range-field"
/>
